export const DEFAULT_THEME = { orange: "#FF5500", turquoise: "#14B8A6", font: "outfit", cursor: true, cursor_color: "#FF5500", particles: true, sounds: true };

export const FONTS = [
  { id: "outfit", name: "Outfit", family: "'Outfit'", note: "Moderna e geométrica (original EDEN)" },
  { id: "space-grotesk", name: "Space Grotesk", family: "'Space Grotesk'", note: "Técnica, com personalidade" },
  { id: "sora", name: "Sora", family: "'Sora'", note: "Limpa e arredondada" },
  { id: "bebas-neue", name: "Bebas Neue", family: "'Bebas Neue'", note: "Condensada, estilo cartaz" },
  { id: "rajdhani", name: "Rajdhani", family: "'Rajdhani'", note: "Angular, ambiente gaming" },
  { id: "playfair", name: "Playfair Display", family: "'Playfair Display'", note: "Elegante, serifada" },
];

export const fontFamily = (id) => (FONTS.find((f) => f.id === id) || FONTS[0]).family;

export const THEME_PRESETS = [
  { name: "EDEN original", orange: "#FF5500", turquoise: "#14B8A6" },
  { name: "Pôr do sol", orange: "#F97316", turquoise: "#06B6D4" },
  { name: "Dourado", orange: "#F5B700", turquoise: "#22C55E" },
  { name: "Vermelho", orange: "#EF4444", turquoise: "#38BDF8" },
  { name: "Roxo neon", orange: "#A855F7", turquoise: "#2DD4BF" },
  { name: "Azul elétrico", orange: "#3B82F6", turquoise: "#F472B6" },
];

export const isHex = (v) => /^#[0-9a-fA-F]{6}$/.test(v || "");

export function hexToRgb(hex) {
  const h = hex.replace("#", "");
  return [0, 2, 4].map((i) => parseInt(h.slice(i, i + 2), 16));
}

const darken = (rgb, f = 0.88) => rgb.map((c) => Math.round(c * f));
const triplet = (rgb) => rgb.join(" ");
const orangeHex = (t) => (isHex(t.orange) ? t.orange : DEFAULT_THEME.orange);

export function applyTheme(theme) {
  const t = { ...DEFAULT_THEME, ...(theme || {}) };
  const root = document.documentElement.style;
  const orange = hexToRgb(isHex(t.orange) ? t.orange : DEFAULT_THEME.orange);
  const turquoise = hexToRgb(isHex(t.turquoise) ? t.turquoise : DEFAULT_THEME.turquoise);
  root.setProperty("--eden-orange", triplet(orange));
  root.setProperty("--eden-orange-hover", triplet(darken(orange)));
  root.setProperty("--eden-turquoise", triplet(turquoise));
  root.setProperty("--eden-ocean", triplet(darken(turquoise, 0.8)));
  root.setProperty("--eden-font-display", fontFamily(t.font));
  root.setProperty("--eden-cursor", triplet(hexToRgb(isHex(t.cursor_color) ? t.cursor_color : orangeHex(t))));
  const [r, g, b] = orange;
  const max = Math.max(r, g, b) / 255, min = Math.min(r, g, b) / 255, l = (max + min) / 2;
  const d = max - min;
  const s = d === 0 ? 0 : d / (1 - Math.abs(2 * l - 1));
  let h = 0;
  if (d !== 0) {
    if (max === r / 255) h = ((g / 255 - b / 255) / d) % 6;
    else if (max === g / 255) h = (b / 255 - r / 255) / d + 2;
    else h = (r / 255 - g / 255) / d + 4;
    h = Math.round(h * 60);
    if (h < 0) h += 360;
  }
  const hsl = `${h} ${Math.round(s * 100)}% ${Math.round(l * 100)}%`;
  root.setProperty("--primary", hsl);
  root.setProperty("--ring", hsl);
}
